import { render, staticRenderFns } from "./task-date.vue?vue&type=template&id=434133bd"
import script from "./task-date.vue?vue&type=script&lang=js"
export * from "./task-date.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports